import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import ABCyaLib from '@abcya/abcya_lib';

export default class CreatorStepInput extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, inputData)
    {
        super(scene);

        this.isActive = false;
        this.lbl = ABCyaPhaser.Text.addText(50, 0, 42, 0x3258a7, FontKeys._asapregular, inputData['lbl'], this, false).setOrigin(0).setWordWrapWidth(550);
        this.inputId = inputData['inputName'];
        let inputWidth = (this.inputId == "body") ? this.scene.scale.width - 115 : 400;
        let inputHeight = (this.inputId == "body") ? 300 : this.lbl.height;
        if (this.inputId == "closing") inputHeight = this.lbl.height / 2;
        this.stepInput = ABCyaPhaser.MobileInput.Input.create(this.scene, ABCyaPhaser.MobileInput.Input.CONFIGS.default, -1500, -1500,
            {
                fontCharacteristics: { font: FontKeys._asapregular, size: 32, color: 0x877D73 },
                background: { width: inputWidth, height: inputHeight, alpha: 1, color: 0xffffff },
                border: "none",
                padding: 10,
                allowOverflow: false,
                maxCharacters: inputData['maxCharacters'],
                isTextArea: this.inputId == "body" || this.inputId == "address" || this.inputId == "closing",
            });
        // there is a weird issue where the DOM element flickers on screen for a frame.. the next two lines prevents this
        this.stepInput._inputfield.parent.style.visibility = "hidden";
        this.scene.time.delayedCall(100, ()=> this.stepInput._inputfield.parent.style.visibility = "visible");
        this.stepInput._inputfield.on("input", () => {
            this.stepInput.text = ABCyaLib.BadWordFilter.replaceBadWords(this.stepInput.text);
            gameData.letterData[this.inputId] = this.stepInput.text
        });
        this.stepInput.text = gameData.letterData[this.inputId];
        this.stepInput.x = 50 + (inputWidth / 2) + 15;
        this.stepInput.y = this.lbl.height + (this.stepInput._inputfield.height / 2) + 15;

        this.add(this.stepInput);

        this.alpha = 0;

        this.setInteractive(
            {
                hitArea: new Phaser.Geom.Rectangle(50, 0, Math.max(this.lbl.width, this.stepInput._inputfield.width) + 20, this.lbl.height + this.stepInput._inputfield.height + 20),
                hitAreaCallback: Phaser.Geom.Rectangle.Contains,
                useHandCursor: false
            }
        );
    }

    slideIn(endX, endY)
    {
        let randomDir = Phaser.Math.Between(-1, 1);
        let xStart = this.scene.scale.width * (randomDir);
        let yStart = 0;
        if (xStart == 0)
        {
            randomDir = Phaser.Math.Between(0, 1);
            yStart = (randomDir == 0) ? -this.scene.scale.height : this.scene.scale.height;
            this.y = yStart;
            this.x = endX;
        }
        else
        {
            this.x = xStart;
            this.y = endY;
        }

        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._fast_whoosh_3, this.scene);
        ABCyaPhaser.Tweens.addTween(this, 600, { x: endX, y: endY, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => this.highLightInput());
    }

    highLightInput(sndNeeded)
    {
        if (sndNeeded == true) ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_whoops, this.scene);
        ABCyaPhaser.Tweens.addTween(this.stepInput, 100, { alpha: 0.6, scale: 1.1, yoyo: true }, Phaser.Math.Easing.Linear, ()=> 
        {
            if(this.isActive) this.setActive(true);
        });
    }

    setActive(isActive)
    {
        this.isActive = isActive;
        if(this.isActive) this.stepInput.focus();
        else this.stepInput.htmlInputElement.blur();
        this.lbl.setColor(isActive ? "#FFFFFF" : "#3258A7");
    }

    slideOut(outPt)
    {
        this.stepInput.htmlInputElement.blur();
        if (this.stepInput.text != "")
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._fast_whoosh_1, this.scene);
            ABCyaPhaser.Tweens.addTween(this, 600, { x: outPt.x, y: outPt.y, alpha: 0, scale: 0 }, Phaser.Math.Easing.Quadratic.Out);
        }
        else
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._fast_whoosh_4, this.scene);
            ABCyaPhaser.Tweens.addTween(this, 600, { x: -this.inputWidth, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
        }
    }

    handleInput(str)
    {
        if(str == "delete") str = "/b";
        if(str == "enter") str = "\n";
        this.stepInput.inputText(str);
        this.stepInput.text = ABCyaLib.BadWordFilter.replaceBadWords(this.stepInput.text);
        gameData.letterData[this.inputId] = this.stepInput.text
    }
}